<template>
    <div
        class="cubeBoxContainer"
        v-bind:class="{
            'cubeBoxContainer-fluid': isFluid,
        }"
    >
        <slot />
    </div>
</template>

<script lang="ts" setup>
    defineProps({
        isFluid: {
            type: Boolean,
            default: () => false,
        },
    });

</script>

<style lang="scss">
    @import "@/components/sideBar/CubeBoxContainer";
</style>
